"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Carousel = require("react-bootstrap/Carousel");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _basicSliderProps = require("./basicSliderProps");

var _basicSliderProps2 = _interopRequireDefault(_basicSliderProps);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

var _styled = require("./styled.sliders");

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var BasicSlider = function BasicSlider(props) {
  var newProps = _extends({}, _basicSliderProps2.default.props, props);
  var style = newProps.style,
      content = newProps.content,
      media = newProps.media,
      updateProps = newProps.updateProps,
      setData = newProps.setData,
      isEditMode = newProps.isEditMode,
      links = newProps.links;


  var slideOneImageProps = {
    src: getPropValue("text", "oneImage", media.oneImage, "media"),
    alt: getPropValue("text", "altOne", media.altOne, "media")
  };

  var slideOneBody = getPropValue("text", "slideOne", content.slideOne, "content");
  var slideOneSubTitle = getPropValue("text", "slideOneSubTitle", content.slideOneSubTitle, "content");
  var slideOneUrl = getPropValue("text", "slideOneUrl", links.slideOneUrl, "content");
  var slideOneLinkTitle = getPropValue("text", "slideOneLinkTitle", links.slideOneLinkTitle, "content");

  var slideTwoImageProps = {
    src: getPropValue("text", "twoImage", media.twoImage, "media"),
    alt: getPropValue("text", "altTwo", media.altTwo, "media")
  };

  var slideTwoBody = getPropValue("text", "slideTwo", content.slideTwo, "content");
  var slideTwoSubTitle = getPropValue("text", "slideTwoSubTitle", content.slideTwoSubTitle, "content");
  var slideTwoUrl = getPropValue("text", "slideTwoUrl", links.slideTwoUrl, "content");
  var slideTwoLinkTitle = getPropValue("text", "slideTwoLinkTitle", links.slideTwoLinkTitle, "content");

  var slideThreeImageProps = {
    src: getPropValue("text", "threeImage", media.threeImage, "media"),
    alt: getPropValue("text", "altThree", media.altThree, "media")
  };

  var slideThreeBody = getPropValue("text", "slideThree", content.slideThree, "content");
  var slideThreeSubTitle = getPropValue("text", "slideThreeSubTitle", content.slideThreeSubTitle, "content");
  var slideThreeUrl = getPropValue("text", "slideThreeUrl", links.slideThreeUrl, "content");
  var slideThreeLinkTitle = getPropValue("text", "slideThreeLinkTitle", links.slideThreeLinkTitle, "content");

  var slideCaptionProps = {
    maxWidth: getPropValue("text", "maxWidth", style.contentWidth, "style"),
    contentPosition: getPropValue("text", "contentPosition", style.contentPosition, "style")
  };

  var slideTitleProps = {
    titleFontSize: getPropValue("text", "titleFontSize", style.titleFontSize, "style"),
    titleColor: getPropValue("text", "titleColor", style.titleColor, "style"),
    textTransform: getPropValue("text", "textTransform", style.textTransform, "style")
  };

  var contentPosition = {
    contentPosition: getPropValue("text", "contentPosition", style.contentPosition, "style")
  };

  return _react2.default.createElement(
    _styled.SliderWrapper,
    null,
    _react2.default.createElement(
      _Carousel2.default,
      { pause: "hover" },
      _react2.default.createElement(
        _Carousel2.default.Item,
        null,
        _react2.default.createElement(_styled.SlideImage, _extends({ className: "d-block w-100" }, slideOneImageProps)),
        _react2.default.createElement(
          _styled.InnerContainer,
          null,
          _react2.default.createElement(
            _styled.SlideCaption,
            slideCaptionProps,
            _react2.default.createElement(
              _styled.SlideTitle,
              _extends({}, slideTitleProps, { className: "mb-3" }),
              _react2.default.createElement(_inlineDiv2.default, {
                isEditMode: isEditMode,
                keyProperty: "slideOne",
                property: "content",
                setData: setData,
                updateProps: updateProps,
                value: slideOneBody
              })
            ),
            _react2.default.createElement(
              "div",
              { className: "content mb-1 mb-md-4" },
              _react2.default.createElement(_inlineDiv2.default, {
                isEditMode: isEditMode,
                keyProperty: "slideOneSubTitle",
                property: "content",
                setData: setData,
                updateProps: updateProps,
                value: slideOneSubTitle
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _Carousel2.default.Item,
        null,
        _react2.default.createElement(_styled.SlideImage, _extends({ className: "d-block w-100" }, slideTwoImageProps)),
        _react2.default.createElement(
          _styled.InnerContainer,
          null,
          _react2.default.createElement(
            _styled.SlideCaption,
            slideCaptionProps,
            _react2.default.createElement(
              _styled.SlideTitle,
              _extends({}, slideTitleProps, { className: "mb-3" }),
              _react2.default.createElement(_inlineDiv2.default, {
                isEditMode: isEditMode,
                keyProperty: "slideTwo",
                property: "content",
                setData: setData,
                updateProps: updateProps,
                value: slideTwoBody
              })
            ),
            _react2.default.createElement(
              "div",
              { className: "content mb-1 mb-md-4" },
              _react2.default.createElement(_inlineDiv2.default, {
                isEditMode: isEditMode,
                keyProperty: "slideTwoSubTitle",
                property: "content",
                setData: setData,
                updateProps: updateProps,
                value: slideTwoSubTitle
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _Carousel2.default.Item,
        null,
        _react2.default.createElement(_styled.SlideImage, _extends({ className: "d-block w-100" }, slideThreeImageProps)),
        _react2.default.createElement(
          _styled.InnerContainer,
          null,
          _react2.default.createElement(
            _styled.SlideCaption,
            slideCaptionProps,
            _react2.default.createElement(
              _styled.SlideTitle,
              _extends({}, slideTitleProps, { className: "mb-3" }),
              _react2.default.createElement(_inlineDiv2.default, {
                isEditMode: isEditMode,
                keyProperty: "slideThree",
                property: "content",
                setData: setData,
                updateProps: updateProps,
                value: slideThreeBody
              })
            ),
            _react2.default.createElement(
              "div",
              { className: "content mb-1 mb-md-4" },
              _react2.default.createElement(_inlineDiv2.default, {
                isEditMode: isEditMode,
                keyProperty: "slideThreeSubTitle",
                property: "content",
                setData: setData,
                updateProps: updateProps,
                value: slideThreeSubTitle
              })
            )
          )
        )
      )
    )
  );
};
exports.default = BasicSlider;